import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ variant = 'full' }) => {
  // Simple footer for auth pages (login/signup)
  if (variant === 'simple') {
    return (
      <footer style={{
        textAlign: 'center',
        marginTop: '24px',
        color: 'rgba(255, 255, 255, 0.8)',
        fontSize: '0.875rem',
      }}>
        <p style={{ marginBottom: '8px' }}>© 2025 SportsBid Arena. All rights reserved.</p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', flexWrap: 'wrap' }}>
          <Link 
            to="/terms-and-conditions" 
            style={{ color: 'rgba(255, 255, 255, 0.7)', textDecoration: 'none', fontSize: '0.8rem' }}
          >
            Terms & Conditions
          </Link>
          <Link 
            to="/privacy-policy" 
            style={{ color: 'rgba(255, 255, 255, 0.7)', textDecoration: 'none', fontSize: '0.8rem' }}
          >
            Privacy Policy
          </Link>
        </div>
      </footer>
    );
  }

  // Full footer for landing page
  return (
    <footer className="py-5 bg-dark text-white position-relative">
      <div className="footer-pattern"></div>
      <div className="container position-relative">
        <div className="row">
          <div className="col-md-6 mb-4 mb-md-0">
            <h3 className="h5 fw-bold mb-3">
              <i className="bi bi-trophy-fill me-2 text-warning" aria-hidden="true"></i>
              SportsBid Arena - Free Auction Site
            </h3>
            <p className="text-white-50 mb-3">
              Your ultimate free platform for cricket auction, football auction, and sports player bidding. 
              Simple auction site for tournament organizers and team owners. Conduct IPL-style, BPL-style auctions 
              with real-time bidding. Best free auction platform for sports leagues.
            </p>
            <div className="social-links">
              <a
                href="https://www.facebook.com/sroy2022"
                className="text-white me-3 hover-grow"
                aria-label="Follow us on Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-facebook fs-5" aria-hidden="true"></i>
              </a>
              <a
                href="https://twitter.com/"
                className="text-white me-3 hover-grow"
                aria-label="Follow us on Twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-twitter fs-5" aria-hidden="true"></i>
              </a>
              <a
                href="https://www.instagram.com/"
                className="text-white me-3 hover-grow"
                aria-label="Follow us on Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-instagram fs-5" aria-hidden="true"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/shuvo2k23"
                className="text-white hover-grow"
                aria-label="Connect on LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-linkedin fs-5" aria-hidden="true"></i>
              </a>
            </div>
          </div>
          <div className="col-md-3 mb-4 mb-md-0">
            <h4 className="h6 fw-bold mb-3">Quick Links</h4>
            <nav>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <Link
                    to="/sign-in"
                    className="text-white-50 text-decoration-none hover-link"
                  >
                    <i className="bi bi-chevron-right me-1" aria-hidden="true"></i>
                    Login to Auction Site
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/sign-up"
                    className="text-white-50 text-decoration-none hover-link"
                  >
                    <i className="bi bi-chevron-right me-1" aria-hidden="true"></i>
                    Sign Up Free
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/terms-and-conditions"
                    className="text-white-50 text-decoration-none hover-link"
                  >
                    <i className="bi bi-chevron-right me-1" aria-hidden="true"></i>
                    Terms & Conditions
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/privacy-policy"
                    className="text-white-50 text-decoration-none hover-link"
                  >
                    <i className="bi bi-chevron-right me-1" aria-hidden="true"></i>
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
          <div className="col-md-3">
            <h4 className="h6 fw-bold mb-3">Contact Us</h4>
            <address className="text-white-50">
              <p className="mb-2">
                <i className="bi bi-envelope me-2" aria-hidden="true"></i>
                <a href="mailto:rshuvo036@gmail.com" className="text-white-50 text-decoration-none">
                  rshuvo036@gmail.com
                </a>
              </p>
              <p className="mb-2">
                <i className="bi bi-geo-alt me-2" aria-hidden="true"></i>
                Rajshahi, Bangladesh
              </p>
            </address>
          </div>
        </div>
        <hr className="my-4 bg-secondary opacity-25" />
        <div className="text-center text-white-50">
          <small>
            © 2025 SportsBid Arena - Free Auction Site. 
            Player bidding platform for cricket, football, basketball tournaments. 
            All rights reserved. v-1.2
          </small>
        </div>
      </div>

      <style>{`
        .footer-pattern {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-image: linear-gradient(
              rgba(255, 255, 255, 0.05) 1px,
              transparent 1px
            ),
            linear-gradient(
              90deg,
              rgba(255, 255, 255, 0.05) 1px,
              transparent 1px
            );
          background-size: 50px 50px;
        }
        .hover-grow {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hover-grow:hover {
          transform: scale(1.05);
        }
        .hover-link:hover {
          color: white !important;
          padding-left: 5px;
          transition: all 0.3s ease;
        }
      `}</style>
    </footer>
  );
};

export default Footer;
